/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

//var player = videojs('video-js');

/* if (!$('.own-skin-page .video-bkg').length) {
    Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
        get: function () {
            return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
        }
    });

    const videoElement = document.getElementById('ID_of_video');
            videoElement.addEventListener('suspend', () => {
                // suspend invoked
                // show play button
            });

            videoElement.addEventListener('play', () => {
                // video is played
                // remove play button UI
            });
    $('body').on('click touchstart', function () {
                const videoElement = document.getElementById('ID_of_video');
                if (videoElement.playing) {
                    // video is already playing so do nothing
                }
                else {
                    // video is not playing
                    // so play video now
                    videoElement.play();
                }
        });
} */

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
/*
$(document).ready(function() {
    // Check if the script has already been executed
    if (!sessionStorage.getItem('countryRedirectExecuted')) {
        // Check if Shopify.country object exists
        if (typeof Shopify !== 'undefined' && typeof Shopify.country !== 'undefined') {
            console.log('Shopify.country object found.');

            // Get the country code
            var countryCode = Shopify.country;
            console.log('Country code:', countryCode);
            
            // Define the root URLs for different countries
            var rootUrls = {
                'FR': '/fr',
                'DE': '/nl'
            };

            // Redirect based on country code
            if (rootUrls.hasOwnProperty(countryCode)) {
                console.log('Redirecting to:', rootUrls[countryCode]);
                window.location.href = rootUrls[countryCode];
            } else {
                // Redirect to a default URL if the country code is not recognized
                console.log('Country code not recognized. Redirecting to default URL.');
                return false;
            }
        } else {
            // If Shopify.country object is not available, handle accordingly
            console.log('Shopify.country object not found.');
            // Redirect to a default URL or handle as per your requirement
        }

        // Mark the script as executed
        sessionStorage.setItem('countryRedirectExecuted', 'true');
    } else {
        console.log('Country redirect script already executed.');
    }
});
*/


jQuery(document).ready(function($) {
  
   // ajax-subscribe
    $('.subscribe-toggle .checkbox-input').change(function () {
        if (this.checked) {
            $(this).closest('.ajax-subscribe').addClass('enabled');
            $(this).closest('.ProductItem').addClass('Subscribed');
        } else {
            $(this).closest('.ProductItem').removeClass('Subscribed');
            $(this).closest('.ajax-subscribe').removeClass('enabled');
        }
    })
    $('.ajax-subscribe [name="selling-plan"]').change(function () {
        $(this).closest('.ajax-subscribe').find('.add-to-cart-subscribe').attr('selling_plan', $(this).val());
        return false;
    })
    $('.add-to-cart-subscribe').click(function () {
        
        addItemToCart($(this).attr('variant_id'),1,$(this).attr('selling_plan'));
        return false;
    })
    function addItemToCart(variant_id, qty, selling_plan) {
        data = {
            "id": variant_id,
            "quantity": qty,
            "selling_plan": selling_plan
        }
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() { 
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
                document.dispatchEvent(new CustomEvent('product:added', {

                    bubbles: true,
                    detail: {
                        variant: {
                            'id': variant_id
                        },
                        quantity: parseInt(1)
                    }
                }))
            }
        });
    }
    // end ajax-subscribe
  
  	
    if ($('#freegift_product').length) {
        function formatMoney(cents, format) {
            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                formatString = format || '${{amount}}';

            function defaultTo(value, defaultValue) {
                return value == null || value !== value ? defaultValue : value;
            }

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = defaultTo(precision, 2);
                thousands = defaultTo(thousands, ',');
                decimal = defaultTo(decimal, '.');
                if (isNaN(number) || number == null) {
                    return 0;
                }
                number = (number / 100.0).toFixed(precision);
                var parts = number.split('.'),
                    dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                    centsAmount = parts[1] ? decimal + parts[1] : '';
                return dollarsAmount + centsAmount;
            }
            var value = '';
            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_space_separator':
                    value = formatWithDelimiters(cents, 2, ' ', '.');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, ',', '.');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ');
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
            }
            if (formatString.indexOf('with_comma_separator') !== -1) {
                return formatString.replace(placeholderRegex, value).replace(',00', '');
            } else {
                return formatString.replace(placeholderRegex, value).replace('.00', '');
            }
        }
        function convertPrice(item) {
            var baseCurrency = window.theme.shopCurrency,
                newCurrency = document.querySelector('.CurrencySelector__Select').value;
            if (!item.hasAttribute('data-currency-' + baseCurrency)) {
                item.setAttribute('data-currency-' + baseCurrency, item.innerHTML);
            }

            // If the amount has already been converted, we leave it alone.
            if (item.getAttribute('data-currency') === newCurrency) {
                return;
            }

            var baseAmount = item.getAttribute('data-currency-' + baseCurrency);
            if (item.hasAttribute('data-currency-' + newCurrency)) {
                item.innerHTML = item.getAttribute('data-currency-' + newCurrency);
            } else {
                var newFormat = window.theme.moneyFormat;
                // We have to normalize by replacing dot by comma and comma by dot
                if (window.theme.moneyFormat.indexOf('with_comma_separator') !== -1) {
                    baseAmount = baseAmount.replace(/[,.]/g, function(match) {
                        // If `,` is matched return `.`, if `.` matched return `,`
                        return match === ',' ? '.' : ',';
                    });
                }
                // Converting to Y for the first time? Let's get to it!
                var cents = window.Currency.convert(parseFloat(baseAmount.replace(/^[^0-9]+|[^0-9.]/g, '', ''), 10) * 100, baseCurrency, newCurrency);
                if (window.theme.currencyConversionRoundAmounts) {
                    cents = Math.round(cents / 100) * 100;
                }
                var newFormattedAmount = formatMoney(cents, newFormat);
                item.innerHTML = newFormattedAmount;
                item.setAttribute('data-currency-' + newCurrency, newFormattedAmount);
            }
            // We record the new currency locally.
            item.setAttribute('data-currency', newCurrency);
        }
        var currency = getCookie('cart_currency');
        var money_format = window.theme.moneyFormat;
        var freegift_product = $('#freegift_product'),
            is_over_price = false;
        var freegift_over_price = Currency.convert($('#freegift_product').attr('over-price'), 'AUD', currency).toFixed(2);
        jQuery.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            dataType: 'json',
            success: function(cart) {
                update_freegift(cart);
            }
        });
        $(document).on('cart:rerender', function(event, cart) {
            update_freegift(cart);
        })
        $(document).on('cart:_replaceContent', function(event) {
            convertPrice($('#sidebar-cart .free-gift .CartItem__Title span:first-of-type')[0]);
            if (freegift_product.length && is_over_price) {
                $('#sidebar-cart .free-gift-wrapper, #sidebar-cart .free-gift').removeClass('hide');
                $('.freegift_order_note').attr('name', 'note');
            } else {
                $('#sidebar-cart .free-gift-wrapper, #sidebar-cart .free-gift').addClass('hide');
                $('.freegift_order_note').attr('name', '');
            }
        })

        function update_freegift(cart) {
            is_over_price = cart.items_subtotal_price >= freegift_over_price;
            if (freegift_product.length && is_over_price) {
                convertPrice($('#sidebar-cart .free-gift .CartItem__Title span:first-of-type')[0]);
                $('#sidebar-cart .free-gift-wrapper, #sidebar-cart .free-gift').removeClass('hide');
                $('.freegift_order_note').attr('name', 'note');
                if (!cart.items.some(el => el.product_id == freegift_product.attr('product-id'))) {
                    jQuery.post('/cart/update.js', "updates[" + freegift_product.attr('variant-id') + "]=1");
                }
            } else {
                if (cart.items.some(el => el.product_id == freegift_product.attr('product-id'))) {
                    jQuery.post('/cart/update.js', "updates[" + freegift_product.attr('variant-id') + "]=0");
                }
            }
        }
    }
    if ($('.own-skin-page .video-bkg').length) {
        function setVideoSize(ele) {
            var video = $(ele), container = video.parent();
            video.css({'max-height': '', 'max-width': '', 'min-heigth': '', 'min-width': ''})
            var video_w = video.width(), video_h = video.height(),
            container_w = container.width(), container_h = container.height();
            var scale_w = video_w / container_w;
            var scale_h = video_h / container_h;
            if (video_w < container_w || video_h < container_h) {
                if (scale_w < scale_h) {
                    video.css('min-width', '100%');
                } else {
                    video.css('min-height', '100%');
                }
            } else {
                if (scale_w < scale_h) {
                    video.css('max-width', '100%');
                } else {
                    video.css('max-height', '100%');
                }                
            }
        }
        setVideoSize('.video-bkg video');
        function resizedw(){setVideoSize('.video-bkg video'); }
        var doit;
        window.onresize = function(){
            clearTimeout(doit);
            doit = setTimeout(resizedw, 100);
        };
    }

    if ($('.template-product').length) {
        var subscribe_label_selector = '.Product__Info .rc-option__subsave .rc_widget__option__label',
            onetime_label_selector = '.Product__Info .rc-option__onetime .rc_widget__option__label',
            onetime_price_selector = '.Product__Info .rc-option__onetime .rc_widget__price',
            subscribe_price_selector = '.Product__Info .rc-option__subsave .rc_widget__price',
            popup_selector = '.Product__Info .rc_popup',
            select_frequency_selector = '.Product__Info .rc_widget__option__plans__dropdown';
        var compare_price = $('.Product__Info .ProductMeta__Price.Price--compareAt').length ? $('.Product__Info .ProductMeta__Price.Price--compareAt').html() : false;
        var regular_price = $('.Product__Info .ProductMeta__Price.Price--highlight').length ? $('.Product__Info .ProductMeta__Price.Price--highlight').html() : $('.Product__Info .ProductMeta__Price').first().html();
        var subscribe_price = false;
        checkSubscribeExists();
        var productUrl = '/products/' + $('.product-url').data('producturl') + '.js';
        if ($('.ProductForm__Variants').length > 0) {
            jQuery.getJSON(productUrl, function(product) {
                var i;
                for (i = 0; i < product.variants.length; ++i) {
                    var priceVariant = product.variants[i].price;
                    var comparePriceVariant = product.variants[i].compare_at_price;
                    var valueVariant = product.variants[i].title;
                    var listItems = $(".ProductForm__Variants li");
                    listItems.each(function(idx, li) {
                        var input = $(li).find('input');
                        var value = input.attr('value');
                        if (value == valueVariant) {
                            $(li).attr('data-price', priceVariant);
                            if (comparePriceVariant)
                                $(li).attr('data-compareprice', comparePriceVariant);
                        }
                    });
                }
            });
        }

        function checkSubscribeExists(count = 0) {
            count++;
            if ($(onetime_label_selector).length && $(subscribe_label_selector).length && $(select_frequency_selector).length && $(onetime_price_selector).html() && $(subscribe_price_selector).html() && $(popup_selector).length) {
                subscribe_price = $(subscribe_price_selector).html();
                $(popup_selector).find('svg').replaceWith('<span class="icon">?</span>');
                $(popup_selector).insertBefore(subscribe_price_selector);

              $(subscribe_label_selector).append('<span class="january">NO COMMITMENT: SKIP OR CANCEL ANYTIME</span>');
              	$('.Product__Info .rc_widget__option[data-option-subsave]').append('<span class="best-value">Best Value</span>');
              
              	$(".subscriptions_description").insertBefore(".Product__Info .rc_widget__option[data-option-subsave] .rc-selling-plans.rc_widget__option__plans");


                $('.Product__Info .rc-selling-plans__label').removeClass('.visually-hidden').append(':');
                var suggested_frequency = false;
                if ($('.subscriptions_suggested').length) {
                    suggested_frequency = $('.subscriptions_suggested').html();
                    $(select_frequency_selector).val($(select_frequency_selector).find('option[data-plan-option=" '+suggested_frequency+' '+((suggested_frequency == 1)?'Month':'Months')+'"]').attr('value')).change();
                }
                var newLabel = '';
                $(select_frequency_selector).find('option').each(function(index) {
                    var planOption = $(this).attr('data-plan-option');
                    if (planOption == ' '+suggested_frequency+' '+((suggested_frequency == 1)?'Month':'Months')) {
                        if (planOption == ' 1 Month') var newLabel = ' ' + $(this).html() + ' (SUGGESTED)';
                        else newLabel = ' ' + $(this).html() + ' (SUGGESTED)';
                    } else {
                        if (planOption == ' 1 Month') var newLabel = ' ' + $(this).html();
                        else newLabel = ' ' + $(this).html();
                    }
                    $(this).html(newLabel);
                })
                toggleDescription();
                toggleMainPrice();
            } else if (count < 3000) {
                setTimeout(function() {
                    checkSubscribeExists(count);
                }, 300)
            }
        }
        $('.Product__Info').on('click', '.rc_widget__option--active', function() {
            toggleDescription();
            toggleMainPrice();
        })

        function toggleDescription() {
            var subscribe_selected = $('.Product__Info [data-radio-subsave]:checked').length;
            if ($('.subscriptions_description').length && subscribe_selected) {
                $('.subscriptions_description').slideDown();
            } else {
                $('.subscriptions_description').slideUp();
            }
        }

        function toggleMainPrice() {
            var subscribe_selected = $('.Product__Info [data-radio-subsave]:checked').length;

            //Loyaty point
            var listItems = $(".ProductForm__Variants li");
            var selected = $('.SizeSwatchList input:checked').val();
            listItems.each(function(idx, li) {
                var input = $(li).find('input');
                var value = input.attr('value');
                var priceRegular = parseFloat($(li).data('price')) / 100;
                if ($(li).data('compareprice'))
                    var priceCompare = parseFloat($(li).data('compareprice')) / 100;

                if (value == selected && priceRegular) {
                    var loyaltyValue = Math.floor(priceRegular);
                    if ($('.loyalty-points').length > 0) $('.loyalty-points').remove();
                    var loyalty = '<span class="loyalty-points">+ ' + loyaltyValue + ' Loyalty Points</span>';
                    $('.ProductMeta').append(loyalty);
                    if (priceCompare)
                        $('.ProductMeta').addClass('has-compare');
                    else
                        $('.ProductMeta').removeClass('has-compare');
                }
            })

            if (subscribe_price) {
                if ($('.ProductForm__Option').length > 0) {
                    selected = $('.SizeSwatchList input:checked').val();
                    listItems.each(function(idx, li) {
                        var input = $(li).find('input');
                        var value = input.attr('value');
                        var priceRegular = parseFloat($(li).data('price')) / 100;
                        if ($(li).data('compareprice'))
                            var priceCompare = parseFloat($(li).data('compareprice')) / 100;

                        var subscribePrice = priceRegular - priceRegular / 100 * 15;
                        var subscribePriceText = '<span class="money">€' + subscribePrice.toFixed(2) + '</span>';
                        var comparePriceText = '<span class="money">€' + priceCompare + '</span>';
                        var regularPriceText = '<span class="money">€' + priceRegular + '</span>';
                        var loyaltyValue = Math.floor(subscribePrice);

                        if (value == selected && priceRegular) {
                            if (priceCompare) {
                                if (subscribe_selected) {
                                    $('.Product__Info .ProductMeta .Price--compareAt').html(regularPriceText);
                                    $('.Product__Info .ProductMeta .Price--highlight').html(subscribePriceText);
                                } else {
                                    $('.Product__Info .ProductMeta .Price--compareAt').html(comparePriceText);
                                    $('.Product__Info .ProductMeta .Price--highlight').html(regularPriceText);
                                    loyaltyValue = Math.floor(priceRegular);
                                }
                            } else {
                                if (subscribe_selected) {
                                    $('.Product__Info .ProductMeta .ProductMeta__Price').first().addClass('Price--compareAt');
                                    if (!$('.Product__Info .ProductMeta .Price--highlight').length) {
                                        $('.Product__Info .ProductMeta .ProductMeta__PriceList').append('<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">' + subscribePriceText + '</span>')
                                    }
                                } else {
                                    $('.Product__Info .ProductMeta .ProductMeta__Price').first().removeClass('Price--compareAt');
                                    $('.Product__Info .ProductMeta .ProductMeta__Price.Price--highlight').remove();
                                    loyaltyValue = Math.floor(priceRegular);
                                }
                            }

                            //loyalty-points
                            if ($('.loyalty-points').length > 0) $('.loyalty-points').remove();
                            var loyalty = '<span class="loyalty-points">+ ' + loyaltyValue + ' Loyalty Points</span>';
                            $('.ProductMeta').append(loyalty);
                        }
                    });
                } else {
                    if (compare_price) {
                        if (subscribe_selected) {
                            $('.Product__Info .ProductMeta .ProductMeta__Price.Price--compareAt').html(regular_price);
                            $('.Product__Info .ProductMeta .ProductMeta__Price.Price--highlight').html(subscribe_price);
                            loyaltyValue = Math.floor(parseFloat($(subscribe_price_selector).html().substring(1)));
                        } else {
                            $('.Product__Info .ProductMeta .ProductMeta__Price.Price--compareAt').html(compare_price);
                            $('.Product__Info .ProductMeta .ProductMeta__Price.Price--highlight').html(regular_price);
                            loyaltyValue = Math.floor(parseFloat($(onetime_price_selector).html().substring(1)));
                        }
                    } else {
                        if (subscribe_selected) {
                            $('.Product__Info .ProductMeta .ProductMeta__Price').first().addClass('Price--compareAt');
                            if (!$('.Product__Info .ProductMeta .Price--highlight').length) {
                                $('.Product__Info .ProductMeta .ProductMeta__PriceList').append('<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">' + subscribe_price + '</span>');
                            }
                            loyaltyValue = Math.floor(parseFloat($(subscribe_price_selector).html().substring(1)));
                        } else {
                            $('.Product__Info .ProductMeta .ProductMeta__Price').first().removeClass('Price--compareAt');
                            $('.Product__Info .ProductMeta .ProductMeta__Price.Price--highlight').remove();
                            loyaltyValue = Math.floor(parseFloat($(onetime_price_selector).html().substring(1)));
                        }
                    }

                    if ($('.loyalty-points').length > 0) $('.loyalty-points').remove();
                    var loyalty = '<span class="loyalty-points">+ ' + loyaltyValue + ' Loyalty Points</span>';
                    $('.ProductMeta').append(loyalty);
                }
            }

            $(".SizeSwatchList input").change(function() {
                var priceRegular = parseFloat($(this).parent().data('price')) / 100;
                if ($(this).parent().data('compareprice'))
                    var priceCompare = parseFloat($(this).parent().data('compareprice')) / 100;
                var subscribePrice = priceRegular - priceRegular / 100 * 15;

                if (priceRegular) {
                    var loyaltyValue = Math.floor(priceRegular);
                    if ($('.loyalty-points').length > 0) $('.loyalty-points').remove();
                    var loyalty = '<span class="loyalty-points">+ ' + loyaltyValue + ' Loyalty Points</span>';
                    $('.ProductMeta').append(loyalty);

                    //if (subscribe_price) {
                    $(onetime_price_selector).text('$' + priceRegular);
                    $(subscribe_price_selector).text('$' + subscribePrice.toFixed(2));

                    var subscribePriceText = '<span class="money">€' + subscribePrice.toFixed(2) + '</span>';
                    var comparePriceText = '<span class="money">€' + priceCompare + '</span>';
                    var regularPriceText = '<span class="money">€' + priceRegular + '</span>';

                    // $('.bold-ro__discounted-price').attr('value', subscribePriceText);
                    // $('.bold-ro__unformatted-price').attr('value', subscribePrice.toFixed(2) * 100);

                    if (priceCompare) {
                        $('.ProductMeta').addClass('has-compare');
                        if ($('.Product__Info .rc_widget__option__input:checked').val() != 0) {
                            setTimeout(function() {
                                $('.Product__Info .Price--compareAt').html(regularPriceText);
                                $('.Product__Info .Price--highlight').html(subscribePriceText);
                                //$('.loyalty-points').hide();
                                loyaltyValue = Math.floor(subscribePrice);
                                if ($('.loyalty-points').length > 0) $('.loyalty-points').remove();
                                var loyalty = '<span class="loyalty-points">+ ' + loyaltyValue + ' Loyalty Points</span>';
                                $('.ProductMeta').append(loyalty);
                            }, 500);
                        }
                    } else {
                        $('.ProductMeta').removeClass('has-compare');
                        if ($('.Product__Info .rc_widget__option__input:checked').val() != 0) {
                            setTimeout(function() {
                                $('.Product__Info .ProductMeta__Price').first().addClass('Price--compareAt');
                                if (!$('.Product__Info .ProductMeta .Price--highlight').length) {
                                    $('.Product__Info .ProductMeta .ProductMeta__PriceList').append('<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">' + subscribePriceText + '</span>')
                                }
                                //$('.loyalty-points').hide();
                                loyaltyValue = Math.floor(subscribePrice);
                                if ($('.loyalty-points').length > 0) $('.loyalty-points').remove();
                                var loyalty = '<span class="loyalty-points">+ ' + loyaltyValue + ' Loyalty Points</span>';
                                $('.ProductMeta').append(loyalty);
                            }, 500);
                        }
                    }
                }
            });
        }
    }

    jQuery.get("https://pro.ip-api.com/json/?key=MQXSLbxUAhwAwzB", function(response) {
        if (response.countryCode == 'AU')
            $('#sidebar-cart').addClass('inau');
        else
            $('#sidebar-cart').removeClass('inau');
    }, "jsonp");
    jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
        }
    });
    calcBannerSliderHeight()
    loyaltyStyle()

    jQuery(window).resize(function() {
        calcBannerSliderHeight();
        loyaltyStyle();
    });
});

function loyaltyStyle(){
    if($('#shopify-section-product-template').length > 0 && $(window).width() <= 800) {
        var priceListWitdh = $('#shopify-section-product-template').width();
        var loyaltyWitdh = $('.loyalty-points').width();
        if($('#shopify-section-product-template .Price--compareAt').length > 0) {
            var compareAtWidth = $('#shopify-section-product-template .Price--compareAt').width();
            var highlightWidth = $('#shopify-section-product-template .Price--highlight').width();

            var totalWidth = loyaltyWitdh + compareAtWidth + highlightWidth + 100;

            if(totalWidth >= priceListWitdh) {
                $('#shopify-section-product-template').addClass('overlap-loyalty');
            } else {
                $('#shopify-section-product-template').removeClass('overlap-loyalty');
            }
        }
    }
}

function openUrl(url){
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

function calcBannerSliderHeight() {
    var windowWidth = jQuery(window).width();
    var sliderHeight = 1630 * windowWidth / 3500;
    jQuery('#shopify-section-slideshow .Slideshow--fullscreen').css('height', sliderHeight + 'px');
}

function upgradeProduct(e) {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    jQuery('body').addClass("processing");
    jQuery.post('/cart/clear.js');
    var productId = $(e).data('productid');
    var qty = $(e).data('qty');
    var itemOldId = $(e).data('itemoldid');

    setTimeout(function() {
        var jqxhr = $.post('/cart/add.js', "id=" + productId + "&quantity=1");
        jqxhr.always(function() {
            document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    variant: {
                        'id': productId
                    },
                    quantity: parseInt(1)
                }
            }))
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            jQuery('body').removeClass("processing");
        });
    }, 1000);

    return false;
}

function quickAddProduct(e) {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    jQuery('body').addClass("processing");
    var productId = $(e).data('productid');

    if ($(e).data('productboost') == '1') {
        setTimeout(function() {
            //var jqxhr = $.post('/cart/add.js', "id="+productId+"&quantity=1");
            var jqxhr = $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    quantity: 1,
                    id: productId,
                    properties: {
                        '_boost': 'boost'
                    }
                }
            });
            jqxhr.always(function() {
                document.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                        variant: {
                            'id': productId
                        },
                        quantity: parseInt(1),
                        properties: {
                            '_boost': 'boost'
                        }
                    }
                }))
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                jQuery('body').removeClass("processing");
            });
        }, 1000);
    } else {
        if ($(e).data('productwinter') == '1') {
            setTimeout(function() {
                //var jqxhr = $.post('/cart/add.js', "id="+productId+"&quantity=1");
                var jqxhr = $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        quantity: 1,
                        id: productId,
                        properties: {
                            '_winter': 'winter'
                        }
                    }
                });
                jqxhr.always(function() {
                    document.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            variant: {
                                'id': productId
                            },
                            quantity: parseInt(1),
                            properties: {
                                '_winter': 'winter'
                            }
                        }
                    }))
                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    jQuery('body').removeClass("processing");
                });
            }, 1000);
        } else {
            setTimeout(function() {
                var jqxhr = $.post('/cart/add.js', "id=" + productId + "&quantity=1");
                jqxhr.always(function() {
                    document.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            variant: {
                                'id': productId
                            },
                            quantity: parseInt(1)
                        }
                    }))
                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    jQuery('body').removeClass("processing");
                });
            }, 1000);
        }
    }

    return false;
}

function keppItem() {
    jQuery('#sidebar-removecart').removeClass('active');
    sessionStorage.removeItem("item_remove");
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
}

jQuery(document).mouseup(function(e) {
    var container = jQuery("#sidebar-removecart .Drawer__Wrapper");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        jQuery("#sidebar-removecart").removeClass('active');
    }
});

function removeItem(e) {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    jQuery('body').addClass("processing");
    var variantId = sessionStorage.getItem("item_remove");

    var jqxhr = $.post('/cart/change.js', "id=" + variantId + "&quantity=0");
    jqxhr.always(function() {
        document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
                variant: {
                    'id': variantId
                },
                quantity: parseInt(0)
            }
        }))
        jQuery('#sidebar-removecart').removeClass('active');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        jQuery('body').removeClass("processing");
        jQuery.getJSON('/cart.js', function(cart) {
            if (cart.item_count == 0 && jQuery(location).attr('pathname') == '/cart') location.reload(true);
        });
    });
  
  	setTimeout(function(){
        jQuery.getJSON('/cart.js', function(cart) {
            console.log(cart.total_price);
            if (cart.total_price == 0) {
                document.dispatchEvent(new CustomEvent('theme:loading:start'));
                var jqxhr = $.post('/cart/change.js', "id=39391201427528" + "&quantity=0");
                jqxhr.always(function() {
                    document.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            variant: {
                                'id': '39391201427528'
                            },
                            quantity: parseInt(0)
                        }
                    }))
                    jQuery('#sidebar-removecart').removeClass('active');
                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    jQuery('body').removeClass("processing");
                    jQuery.getJSON('/cart.js', function(cart) {
                        if (cart.item_count == 0 && jQuery(location).attr('pathname') == '/cart') location.reload(true);
                    });
                });
            }
        });
    },500)
}

function upgradeOpen() {
    if (jQuery('.Cart__UpgradeSave').hasClass('close')) {
        jQuery('.Cart__UpgradeSave').addClass('open').removeClass('close');
        jQuery('.Drawer__Main').addClass('show');
    } else {
        jQuery('.Cart__UpgradeSave').addClass('close').removeClass('open');
        jQuery('.Drawer__Main').removeClass('show');
    }
}

function upgradeClose() {
    if (!jQuery('.Cart__UpgradeSave').hasClass('close')) {
        jQuery('.Cart__UpgradeSave').addClass('close').removeClass('open');
        jQuery('.Drawer__Main').removeClass('show');
    } else {
        jQuery('.Cart__UpgradeSave').addClass('open').removeClass('close');
        jQuery('.Drawer__Main').addClass('show');
    }
}

function CollectionAddToCart() {
    $(document).on('click','.CollectionAddToCart', function(e) {
      document.dispatchEvent(new CustomEvent('theme:loading:start')); 
        e.preventDefault();
        var this_form = $(e.target).parents('form:first');
        var tagsVal = this_form.find('input[name="tags"]').val();
        var this_variant = this_form.data('variant-id');
        var jqxhr = $.post('/cart/add.js', $(this_form).serialize());

        var ref = $(e.target).data('ref');
        if (ref && ref.length) {
            $.getJSON(ref, function(data) {

            });
        }

        jqxhr.always(function() {
          document.dispatchEvent(new CustomEvent('theme:loading:end')); 
            document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    variant: {
                        'id': this_variant
                    },
                    quantity: parseInt(1)
                }
            }))
        })
    });
}

function YotpoWrapper() {
    var height = $('.y-image-overlay ').height();
    $('.yotpo-pictures-widget').height(height);
}

if (!$('#recharge-novum').length) {
    $(window).load(function() {

        if ($(window).width() <= 640) {
            var navtop = $('.Section--spacingNormal.featured-reviews .Container div#featured-reviews-images h2').outerHeight(true) + $('.Section--spacingNormal.featured-reviews .Container div#featured-reviews-images .image-wrapper').outerHeight() / 2;
            $('.Section--spacingNormal.featured-reviews .Container div#featured-reviews-content .review-text a').css('top', navtop).css('opacity', '1');
        }

        CollectionAddToCart();
        YotpoWrapper();

    });

    $(window).resize(function() {
        YotpoWrapper();
        if ($(window).width() <= 640) {
            var navtop = $('.Section--spacingNormal.featured-reviews .Container div#featured-reviews-images h2').outerHeight(true) + $('.Section--spacingNormal.featured-reviews .Container div#featured-reviews-images .image-wrapper img').height() / 2;
            $('.Section--spacingNormal.featured-reviews .Container div#featured-reviews-content .review-text a').css('top', navtop).css('opacity', '1');
        }
    });
}
/*
$.ajax({
  url: "https://jessicasepel.com/yotpo.json", 
  success: function(data){
    $('#reviews-count').text(numberWithCommas(data.total));
  }, 
  cache: false
});
setInterval(function(){
  $.ajax({
    url: "https://jessicasepel.com/yotpo.json", 
    success: function(data){
      $('#reviews-count').text(numberWithCommas(data.total));
    }, 
    cache: false
  });
}, 5000);
*/
function lazyload() {
    const images = document.querySelectorAll('[dota-src], [dota-srcset]')
    const config = {
        rootMargin: '0px 0px 0px 0px',
        threshold: 0
    };

    let observer = new IntersectionObserver(function(entries, self) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                preloadImage(entry.target);
                //   Stop watching and load the image
                self.unobserve(entry.target);
            }
        });
    }, config);

    images.forEach(image => {
        observer.observe(image);
    });
}

function preloadImage(img) {
    const src = img.getAttribute('dota-src');
    const srcset = img.getAttribute('dota-srcset');
    if (src) {
        img.src = src;
    }
    if (srcset) {
        img.srcset = srcset;
    }
}

lazyload();

$('body').on('click','.yotpo.product-stars',function(){
    $('html, body').animate({
      scrollTop: $('#customer-reviews-header').offset().top
    }, 1000)
})

//---------------------------------//
//Date - 08-09-2022
//Dev - Simaran
// Load The Document On Ready Function
$(document).ready(function(){

  //Loop Over The Subscriber Link To Get The Dynamic Values
  $(".subscribe-link span").each(function(){

  //Get text of subscribe link on collection page
  var currentVal = $(this).text();

  //Change the Whole Text to the Lower Case
  var lowercase = currentVal.toLowerCase();

   //Call a function for  formatted words to Upper case
   str1 = capitalizeFirstLetter(lowercase);

   //Function for split the words and make first letter capital
   const uppercaseWords = str => str.replace(/^(.)|\s+(.)/g, c => c.toUpperCase());

  //Call The Function
  var formattedDynamicText = uppercaseWords(str1);  

    //Replace Formatted text 
   $(".subscribe-link span").text(formattedDynamicText);
});

//function for split the first letter of words to Upper case
 function capitalizeFirstLetter(string){
   
  return string.charAt(0).toUpperCase() + string.slice(1);
   
} 
  
 //Run a Loop over the product title on collection page for text replacement
 $(".ProductItem__Title a").each(function(){

     //Get the All product Titles text.
     var ProductTitles = $(this).text();

     //Split the Product Title Words.
     var result= ProductTitles.split(' - ');

     // Get First element Value
     var firstValue = result[0];
   
     //Get Second element Value.
     var secondValue = result[1];

     //Add function for check the numeric value exist in the values.
     var check =  containsNumber(secondValue)

    //Condition if there is any sample exist.
      if(secondValue != undefined && check == true){

        //Replace the text.
  		$(this).html(firstValue + '<br><span class="newClass">'+secondValue+'<span>'); 

        //If condition close
      }
 });
//Function for check the numbers in string 
function containsNumber(str) {
  return /\d/.test(str);
}

});


/* Blog Pagination */


$('.ArticleNextPrev .prev-post').on('click',function(){
   let href= $(this).find('a').attr('href');
    window.location.href=href;
})
$('.ArticleNextPrev .next-post').on('click',function(){
   let href= $(this).find('a').attr('href');
    window.location.href=href;
})


/* Blog Pagination End */





/* Custom Filter Functionality */
const apply_c_filter=()=>{
   if(Collectionfilters.length>0){
      $('.ProductItem').closest('div.Grid__Cell').addClass('hide_tag');
       Collectionfilters.forEach(function(currentValue){
         
           $('.ProductItem').each(function(current){
             let cur_tag =$(this).attr(currentValue);
             if(typeof cur_tag !== 'undefined' && cur_tag !== false){
               $(this).closest('div.Grid__Cell').removeClass('hide_tag');
             } 
           });
       });
     }else{
       $('.ProductItem').closest('div.Grid__Cell').removeClass('hide_tag');
     } 
}
  let Collectionfilters=[];
  $(document).on('click','.filter-property',function(e){
    
      let cthis=e.target;
      let filterFor=$(cthis).attr('filter-type');
      let filterValue=$(cthis).attr('filter-value');
    
      if(Collectionfilters.includes(filterValue)===true){
            $(cthis).removeClass('active');
            const index = Collectionfilters.indexOf(filterValue);
            if (index > -1) { 
              Collectionfilters.splice(index, 1); 
            }
      }else{
            Collectionfilters.push(filterValue);
            $(cthis).addClass('active');
      }
      apply_c_filter();
      $(window).scrollTop($(".CollectionInner__Products").offset().top -100);


  });
  
  
  (function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }
  
   var PriceRange = /*#__PURE__*/function (_HTMLElement) {
  _inherits(PriceRange, _HTMLElement);

  var _super = _createSuper(PriceRange);

  function PriceRange() {
    _classCallCheck(this, PriceRange);

    return _super.apply(this, arguments);
  }

  _createClass(PriceRange, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;

      this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
      this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
      this.textInputLowerBound = this.querySelector('.price-range__input:first-child input');
      this.textInputHigherBound = this.querySelector('.price-range__input:last-child input'); // Select whole text on focus for text field to improve user experience

      this.textInputLowerBound.addEventListener('focus', function () {
        return _this.textInputLowerBound.select();
      });
      this.textInputHigherBound.addEventListener('focus', function () {
        return _this.textInputHigherBound.select();
      }); // Keep in sync the range with the text input fields

      this.textInputLowerBound.addEventListener('change', function (event) {
        event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        _this.rangeLowerBound.value = event.target.value;

        _this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"));
      });
      this.textInputHigherBound.addEventListener('change', function (event) {
        event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        _this.rangeHigherBound.value = event.target.value;

        _this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"));
      });
      this.rangeLowerBound.addEventListener('change', function (event) {
        _this.textInputLowerBound.value = event.target.value;

        _this.textInputLowerBound.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
      this.rangeHigherBound.addEventListener('change', function (event) {
        _this.textInputHigherBound.value = event.target.value;

        _this.textInputHigherBound.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }); // We also have to bound the two range sliders

      this.rangeLowerBound.addEventListener('input', function (event) {
        event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

        event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
        _this.textInputLowerBound.value = event.target.value;
      });
      this.rangeHigherBound.addEventListener('input', function (event) {
        event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

        event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
        _this.textInputHigherBound.value = event.target.value;
      });
    }
  }]);

  return PriceRange;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
window.customElements.define('price-range', PriceRange);
  
   
})();






(()=>{
  let element = document.querySelector('#shopify-section-collection-template section');
  if(element!==null){
        let delegateElement = new domDelegate.Delegate(element);
	let toolbarElement = element.querySelector('.CollectionToolbar');
	let collectionInnerElement = element.querySelector('.CollectionInner__Products');
	let settings = JSON.parse(element.getAttribute('data-section-settings'));
	
	
	var sortPopoverElement = document.getElementById('collection-sort-popover');

 /*  if (sortPopoverElement) {
	var sortPopover = new Popover(sortPopoverElement, {
	  onValueChanged: _sortByChanged.bind(this)
	});
   } */ // Create the filter drawer if available
   
   
   var filterDrawerElement = document.getElementById('collection-filter-drawer');






  var collectionImageElement = element.querySelector('.PageHeader__ImageWrapper');

  if (collectionImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
	parallaxInstance = new Rellax('.PageHeader__ImageWrapper', {
	  speed: -7,
	  center: false,
	  round: true
	});
  } // Setup product item color swatch


 
  
  /*let timeline = new TimelineLite({
	delay: window.theme.showPageTransition ? 0.5 : 0
  });*/
  
  function _reloadProducts(url) {
	document.dispatchEvent(new CustomEvent('theme:loading:start'));

	if (history.replaceState) {
	  window.history.pushState({
		path: url
	  }, '', url);
	}

	var currentUrl = new URL(window.location);
	currentUrl.searchParams.set('section_id', settings['sectionId']);

	try {
	  fetch(currentUrl.toString(), {
	  }).then(function (response) {
		response.text().then(function (content) {
			document.dispatchEvent(new CustomEvent('theme:loading:end'));
		  var tempElement = document.createElement('div');
		  tempElement.innerHTML = content;
		  collectionInnerElement.innerHTML = tempElement.querySelector('.CollectionInner__Products').innerHTML;
		  var toolbarFilter = tempElement.querySelector('.CollectionToolbar__Item--filter');

		  if (toolbarFilter) {
			var newToolbarFilter = element.querySelector('.CollectionToolbar__Item--filter');

			newToolbarFilter.innerHTML = toolbarFilter.innerHTML;
			newToolbarFilter.className = toolbarFilter.className;
		  } // We also replace the filters


		  var collectionFiltersDrawer = element.querySelector('#collection-filters-drawer-form'),
			  collectionFiltersSidebar = element.querySelector('#collection-filters-sidebar-form');

		  if (collectionFiltersDrawer) {
			var newDrawerContent = tempElement.querySelector('#collection-filters-drawer-form');
			Array.from(collectionFiltersDrawer.querySelectorAll('.Collapsible')).forEach(function (collapsible) {
			  var newCollapsible = newDrawerContent.querySelector("[data-filter-index=\"".concat(collapsible.getAttribute('data-filter-index'), "\"]"));

			  if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
				newCollapsible.style.overflow = 'visible';
				newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true');
				newCollapsible.lastElementChild.style.height = 'auto';
				newCollapsible.lastElementChild.style.overflow = 'visible';
			  }
			});
			collectionFiltersDrawer.innerHTML = newDrawerContent.innerHTML;
			new ProductItemColorSwatch(element.querySelector('.ProductList'));
		  }

		  if (collectionFiltersSidebar) {
			var newSidebarContent = tempElement.querySelector('#collection-filters-sidebar-form');
			Array.from(collectionFiltersSidebar.querySelectorAll('.Collapsible')).forEach(function (collapsible) {
			  var newCollapsible = newSidebarContent.querySelector("[data-filter-index=\"".concat(collapsible.getAttribute('data-filter-index'), "\"]"));

			  if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
				newCollapsible.style.overflow = 'visible';
				newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true');
				newCollapsible.lastElementChild.style.height = 'auto';
				newCollapsible.lastElementChild.style.overflow = 'visible';
			  }
			});
			collectionFiltersSidebar.innerHTML = newSidebarContent.innerHTML;
		  }

		  document.dispatchEvent(new CustomEvent('theme:loading:end'));



		  var elementOffset = element.querySelector('.CollectionMain').getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue('--header-height'));

		  /*if (Responsive.matchesBreakpoint('lap-and-up') && toolbarElement && _this4.toolbarElement.clientHeight === 0) {
			elementOffset -= 50;
		  }*/

		  if (elementOffset < 0) {
			window.scrollBy({
			  top: elementOffset,
			  behavior: 'smooth'
			});
		  }
		});
	  });
	} catch (exception) {}
  }
  
  
  function _onFiltersCleared(event) {
	_reloadProducts(event.target.getAttribute('data-url'));
  }
  
  function _onFilterChanged(event) {
    
	var formData = new FormData(event.target.closest('form.form_s'));
	var searchParamsAsString = new URLSearchParams(formData).toString();

	_reloadProducts("".concat(window.location.pathname, "?").concat(searchParamsAsString));
  }
  
  function _attachListeners() {
	
	delegateElement.on('click', '[data-action="clear-filters"]', _onFiltersCleared.bind(this));
	delegateElement.on('change', '[name^="filter."]', _onFilterChanged.bind(this));
    delegateElement.on('click', '[data-action="apply-tags"]', _onFilterChanged.bind(this));
    
    
	window.addEventListener('popstate', function (event) {
	  if (event.state.path) {
		window.location.href = event.state.path;
	  }
	});
  }
  
 /* _setupAnimation();*/

  _attachListeners();
    
    $(document).on('click','.filter-link',function(){
        event.preventDefault();
        
        let u=$(event.target).attr('href');
       _reloadProducts(u);
    })
    
  }
	
	
   
})()


$(document).on('click','.filter_product_t',function(){
    $(event.target).closest('.filter_container').toggleClass('active');
})
$(document).on('click','.filter_white_head',function(){
    $(event.target).closest('.filter_white').toggleClass('active');
})

$(document).on('click','.mobile_view .filter-link',function(){

    $('.mobile_view .filter-link').removeClass('active');
    $('.mobile_view .filter_white_head').html($(event.target).text());

    $(event.target).addClass('active');
    $(event.target).closest('.filter_white').toggleClass('active');
})

$('.product_type_button').on('click',function(){
    $('#collection-filter-drawer').removeClass('filter_by_open');
    $('#collection-filter-drawer').addClass('product_type_open');
})
$('.filter_type_button').on('click',function(){
    $('#collection-filter-drawer').addClass('filter_by_open');
    $('#collection-filter-drawer').removeClass('product_type_open');
})





/* Custom Filter Functionality End */

$(document).on('click','.view-more-description',function(){
  $(event.target).closest('.description-view-less').addClass('more');
});

$(document).ready(function() {
    $('.winter.boost .money').css('color', 'black');
    $('.winter.boost .CartItem__Price.Price.Price--compareAt').hide();
    $('.winter.boost .CartItem_Label.CartItem_Label--Free').hide();
});

$(document).ready(function() {
    // Check each select element to see if 'hide-parent' value exists
    $('select').each(function() {
        // Check if there is an option with the value 'hide-parent'
        if ($(this).find('option[value="hide-parent"]').length > 0) {
            // Hide the div with class 'other-options'
            $('.other-options-wrapper').hide();
            // Break the loop since we only need to hide once
            return false;
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
  // Function to hide parent element if 'Rte' content is 'hide-parent' or empty
  function hideParentIfNeeded(parentSelector) {
    var parents = document.querySelectorAll(parentSelector);

    parents.forEach(function(parent) {
      var rteElement = parent.querySelector('.Rte');

      if (rteElement && (rteElement.textContent.includes('hide-parent') || rteElement.textContent.trim() === '')) {
        parent.style.display = 'none';
      }
    });
  }

  // Check for 'Collapsible Collapsible--large' elements
  hideParentIfNeeded('.Collapsible.Collapsible--large');
  // Check for 'Product__AdditionalDescription' elements
  hideParentIfNeeded('.Product__AdditionalDescription');
});
